// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewBookingDetails-containerWith-Qwcfk {
    width: 100%;
    max-width: 1260px !important;
    margin: 0 auto;
}

.ViewBookingDetails-container-wtluc {
    max-width: 100%;
}

/* Text - Start */

.ViewBookingDetails-subText-Tesbg {
    color: var(--secondary-foreground);
    font-size: 14px;
}

/* Text - End */

/* Header */

.ViewBookingDetails-navigationLink-XFfyM a {
    padding-right: 20px !important;
    padding-left: 20px !important;
    color: var(--primary-foreground) !important;
    font-size: 18px;
    border-bottom: 2px solid transparent;
}

.ViewBookingDetails-navigationLink-XFfyM a:hover,
.ViewBookingDetails-navigationLink-XFfyM a:focus,
.ViewBookingDetails-navigationLink-XFfyM a:active {
    border-bottom: 2px solid var(--primary-foreground);
}

/* Header */

/* commonCss */

.ViewBookingDetails-noPadding-xIlhz {
    padding: 0;
}

.ViewBookingDetails-heading-T_i6d {
    padding: 30px 0px 24px 0px;
    font-weight: 700;
    font-size: 24px;
    color: var(--primary-foreground);
}

.ViewBookingDetails-widthInner-A0PjK {
    margin: 0px auto 0px auto;
    border-radius: 4px;
    padding: 0px;
    margin: 0px 15px 30px;
}

.ViewBookingDetails-noMargin-uYGmq {
    margin: 0;
}

.ViewBookingDetails-formControlInputTable-eEHMc {
    border: none;
    width: 100px;
    height: auto;
}

.ViewBookingDetails-backBtn-rFfSh {
    margin-left: 15px;
    display: inline-block;
}

.ViewBookingDetails-backBtn-rFfSh:active,
.ViewBookingDetails-backBtn-rFfSh:hover,
.ViewBookingDetails-backBtn-rFfSh:focus {
    color: var(--primary-bg);
    text-decoration: none !important;
}

.ViewBookingDetails-textAlignRight-QSESo {
    text-align: right;
}

.ViewBookingDetails-displayInlineBlock-woiDM {
    display: inline-block;
}

.ViewBookingDetails-displayBlock-QUnPr {
    display: block;
}

.ViewBookingDetails-countryCode-nH1k9 {
    width: 15%;
    vertical-align: top;
}

.ViewBookingDetails-vtrMiddle-audPC {
    vertical-align: middle;
}

/* commonCss */

.ViewBookingDetails-editIcon-O_vPC {
    width: 100%;
    width: 15px;
    vertical-align: middle;
    margin-right: 3px;
}

.ViewBookingDetails-iconBtn-NPKiq,
.ViewBookingDetails-iconBtn-NPKiq:hover,
.ViewBookingDetails-iconBtn-NPKiq:focus {
    padding: 0 !important;
    background: transparent !important;
    color: var(--danger-action-color) !important;
    border: 0 !important;
    white-space: nowrap;
    font-size: 16px !important;
    text-decoration: unset !important;
    cursor: pointer;
}

.ViewBookingDetails-profileImg-QQtJ6 {
    width: 100%;
    height: auto;
    margin-bottom: 18px;
}

.ViewBookingDetails-profileImgSection-nZ51z {
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    border-radius: 12px;
    border: 1px solid var(--primary-border);
    background: var(--primary-input-bg);

}

.ViewBookingDetails-profileImgWidth-Ay6gi {
    margin: 0;
    max-width: 100% !important;
}

.ViewBookingDetails-searchInput-rpEDD {
    width: 100%;
    max-width: 320px;
}

.ViewBookingDetails-backgroundImg-JMxaC {
    padding-top: 42%;
    background-repeat: no-repeat;
    background-size: contain;
    margin-bottom: 18px;
    border-radius: 4px;
    background-color: transparent;
    background-position: center;
    margin-top: 6px;
    border: 1px dashed var(--primary-border);
    border-radius: 12px;
}

/*******************Export CSV section start ******************/

.ViewBookingDetails-exportDisplay-OM8AK {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin-bottom: 18px;
    gap: 18px;
    grid-gap: 18px;
}

.ViewBookingDetails-exportTextSection-xy5JT {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.ViewBookingDetails-exportText-jZGlX {
    display: inline-block;
    padding-right: 5px;
}

.ViewBookingDetails-exportTextContainer-frCYU {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    color: var(--primary-link-foreground) !important;
    text-decoration: unset !important;
    border-bottom: 1px solid var(--primary-link-foreground);
}

.ViewBookingDetails-vtrTextBottom-OK7AR {
    vertical-align: text-bottom;
}

.ViewBookingDetails-exportImg-Dkqaq {
    width: 100%;
    max-width: 14px;
    height: 14px;
    -o-object-fit: contain;
       object-fit: contain;
}

/*******************Export CSV section End ******************/

.ViewBookingDetails-noLink-IlcBP,
.ViewBookingDetails-noLink-IlcBP:hover {
    color: var(--primary-link-foreground) !important;
    cursor: pointer;
}

.ViewBookingDetails-singleCard-V8UgY {
    width: 500px;
    margin: 0 auto;
}

.ViewBookingDetails-defaultIcon-YnNPB {
    background-size: 50px;
}

.ViewBookingDetails-assignProviderSearchInput-xlVjG {
    width: 100%;
    max-width: 324px;
}

.ViewBookingDetails-searchGroupContainer-Fd2ND {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

@media (max-width: 767px) {
    .ViewBookingDetails-searchGroupContainer-Fd2ND {
        width: 100%;
    }

}

@media (max-width: 1199px) and (min-width: 1024px) {
  .ViewBookingDetails-widthInner-A0PjK {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .ViewBookingDetails-aboutGrid-ZtIsD img {
    position: relative;
    top: -25px !important;
  }

  .ViewBookingDetails-responsiveView-sGjt0 {
    width: 100% !important;
    max-width: 175px !important;
  }

  .ViewBookingDetails-positionFive-joHMf {
    top: 28% !important;
  }

  .ViewBookingDetails-positionTwo-ERm4I {
    top: 28% !important;
  }

  .ViewBookingDetails-responsiveContentOne-jmfy6 {
    top: -50px !important;
  }

  .ViewBookingDetails-positionFour-BecV8 {
    top: -50px !important;
  }

  .ViewBookingDetails-totalCss-YlpZc {
    width: 100% !important;
  }


}

@media (max-width: 1024px) {
  .ViewBookingDetails-navbar-expand-lg-MXk91 .ViewBookingDetails-navbar-toggler-xs4I4 {
    display: block !important;
    position: absolute;
    top: 23px;
    right: 20px;
  }

  .ViewBookingDetails-profileImgSection-nZ51z {
    padding: 18px;
  }
}

@media (max-width: 1023px) and (min-width: 768px) {

  .ViewBookingDetails-navigationLink-XFfyM a {
    color: var(--primary-foreground) !important;
  }

  .ViewBookingDetails-widthInner-A0PjK {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .ViewBookingDetails-responsiveContentOne-jmfy6 {
    width: 300px !important;
    position: absolute !important;
    top: -42px !important;
    left: -5% !important;
  }

  .ViewBookingDetails-positionTwo-ERm4I {
    top: 24% !important;
    left: -5% !important;
  }

  .ViewBookingDetails-positionThree-YoZ3S {
    top: 70% !important;
    left: -5% !important;
  }

  .ViewBookingDetails-positionFour-BecV8 {
    top: -42px !important;
    right: -5% !important;
  }

  .ViewBookingDetails-positionFive-joHMf {
    top: 20% !important;
    right: -5% !important;
  }

  .ViewBookingDetails-positionSix-YAiCw {
    top: 70% !important;
    right: -5% !important;
  }

  .ViewBookingDetails-responsiveView-sGjt0 {
    width: 100% !important;
    max-width: 115px !important;
  }

  .ViewBookingDetails-aboutGrid-ZtIsD img {
    top: -1px !important;
  }

  .ViewBookingDetails-contentOne-iYSmI h1 {
    font-size: 16px !important;
  }

  .ViewBookingDetails-contentOne-iYSmI p {
    font-size: 12px !important;
  }


  .ViewBookingDetails-totalCss-YlpZc {
    width: 100% !important;
  }

  .ViewBookingDetails-padding-OAsta {
    padding: 0px 0 0 60px !important;
  }

  .ViewBookingDetails-singleCard-V8UgY {
    width: 100% !important;
  }

  .ViewBookingDetails-navigationLink-XFfyM a:hover,
  .ViewBookingDetails-navigationLink-XFfyM a:focus,
  .ViewBookingDetails-navigationLink-XFfyM a:active {
    border-bottom: 2px solid transparent;
  }
}

@media screen and (max-width: 823px) {
  .ViewBookingDetails-navbar-collapse-LuWqc.ViewBookingDetails-show-WL5NK {
    right: 0% !important;
    top: 0 !important;
  }

  .ViewBookingDetails-navbar-collapse-LuWqc {
    position: fixed !important;
    height: 100vh !important;
    width: 100% !important;
    background: #fff !important;
    right: -100% !important;
    -webkit-transition: 0.5s !important;
    transition: 0.5s !important;
  }
}

@media (max-width: 767px) {
  .ViewBookingDetails-content-C_VIc {
    float: none;
  }

  .ViewBookingDetails-mr-auto-Rf3hm.ViewBookingDetails-navbar-nav-p9GJN {
    padding-bottom: 80px !important;
  }

  .ViewBookingDetails-navigationLink-XFfyM a {
    color: var(--primary-foreground) !important;
  }

  .ViewBookingDetails-footer-Y_azl {
    padding: 35px 0 0 15px;
  }

  .ViewBookingDetails-widthInner-A0PjK {
    width: 100%;
    margin: 0px auto 0 auto;
    border-radius: 0;
  }

  .ViewBookingDetails-responsiveNoPadding-mn5tc {
    padding: 0px !important;
  }

  .ViewBookingDetails-contentOne-iYSmI {
    position: relative !important;
    text-align: left !important;
    width: auto !important;
    padding: 0px 15px !important;
  }

  .ViewBookingDetails-aboutContainer-XDtaG {
    padding: 30px 0 30px !important;
  }

  .ViewBookingDetails-noPosition-tCPud {
    left: 0 !important;
    right: 0 !important;
    top: 0 !important;
  }

  .ViewBookingDetails-mobimleImg-vNAKj {
    display: none !important;
  }

  .ViewBookingDetails-totalCss-YlpZc {
    width: 100% !important;
  }

  .ViewBookingDetails-imgWidth-DQ9cO {
    padding: 18px !important;
  }

  .ViewBookingDetails-searchInput-rpEDD,
  .ViewBookingDetails-assignProviderSearchInput-xlVjG {
    max-width: 100% !important;
  }

  .ViewBookingDetails-exportText-jZGlX {
    display: inline-block;
  }

  .ViewBookingDetails-gridSystem-z2JGr {
    grid-template-columns: auto !important;
  }

  .ViewBookingDetails-padding-OAsta {
    padding: 52px 0 0 0 !important;
  }

  .ViewBookingDetails-heading-T_i6d {
    padding: 30px 0 24px !important;
  }

  .ViewBookingDetails-singleCard-V8UgY {
    width: 100% !important;
  }

  .ViewBookingDetails-displayGrid-Uw3sr {
    grid-template-columns: 100% !important;
    grid-gap: 12px;
  }

  .ViewBookingDetails-boxInner-P2XY0 {
    padding: 35px 0 !important;
  }

  .ViewBookingDetails-navigationLink-XFfyM a:hover,
  .ViewBookingDetails-navigationLink-XFfyM a:focus,
  .ViewBookingDetails-navigationLink-XFfyM a:active {
    border-bottom: 2px solid transparent;
  }
}

@media (max-width: 480px) and (min-width: 320px) {
  .ViewBookingDetails-whiteDropdown-UPNRO select {
    width: 120px !important;
  }
}

.ViewBookingDetails-addOrChangeBtn-y9Vzj {
    float: right;
    color: var(--primary-link-foreground) !important;
    text-decoration: underline !important;
    cursor: pointer;
}

.ViewBookingDetails-grid-Fis0H {
    display: grid;
    grid-template-columns: 25px auto;
    grid-gap: 12px;
    padding-bottom: 20px;
    position: relative;
    height: 65px;
}

.ViewBookingDetails-iconWidth-hx_No {
    width: 100%;
    max-width: 25px;
}

.ViewBookingDetails-smallContent-dfPGt {
    font-size: 14px;
    color: var(--secondary-foreground);
}

.ViewBookingDetails-grid-Fis0H::after {
    content: '';
    position: absolute;
    z-index: 1;
    top: 29px;
    bottom: 0;
    left: 12px;
    border-left: 1.5px dashed var(--primary-border);
    height: 40px;
}

.ViewBookingDetails-grid-Fis0H:last-child::after {
    display: none;
}

.ViewBookingDetails-grid-Fis0H:last-child {
    padding-bottom: 0;
    height: auto;
}

.ViewBookingDetails-completed-IHqMi {
    position: relative;
}

.ViewBookingDetails-completed-IHqMi::after {
    content: '';
    position: absolute;
    z-index: 1;
    top: 29px;
    bottom: 0;
    left: 12px;
    border-left: 1.5px dashed var(--primary-bg) !important;
    height: 40px;
}

.ViewBookingDetails-paddingTop-hkA4_ {
    padding-top: 15px;
}

.ViewBookingDetails-tableGrid-YyXiN {
    display: grid;
    grid-template-columns: 100% auto;
}

.ViewBookingDetails-tablePadding-hd5Cs {
    padding-left: 10px;
}

.ViewBookingDetails-fontCss-lso5x {
    font-size: 15px;
    color: var(--secondary-foreground);
}

.ViewBookingDetails-downIconCss-mcl9A {
    position: absolute;
    top: 30px;
    right: 20px;
    font-size: 24px;
}

.ViewBookingDetails-name-g2M6e {
    padding-left: 12px;
    display: inline-block;
    padding-right: 40px;
}

.ViewBookingDetails-pricingCss-XV27u {
    font-size: 14px;
    color: var(--primary-bg);
    padding-top: 2px;
}

.ViewBookingDetails-timeCss-lqu4h {
    padding-left: 6px;
    position: relative;
    top: 1px;
}

.ViewBookingDetails-timeGrid-T2XFR {
    display: grid;
    grid-template-columns: 33.33% 33.33% 33.33%;
    padding: 13px 15px;
    border-bottom: 1px solid var(--primary-border);
}

.ViewBookingDetails-timeGrid-T2XFR:last-child {
    border-bottom: 0;
}

.ViewBookingDetails-totalCss-YlpZc {
    padding: 15px;
    border: 1px solid var(--primary-border);
    max-width: 350px;
    border-radius: 10px;
    margin: 15px auto;
    text-align: center;
}

.ViewBookingDetails-subCategoryImage-XsU9O {
    width: 100%;
    max-width: 100px;
}

.ViewBookingDetails-jobPhotos-EVT6c {
    margin-bottom: 15px;
    cursor: pointer;
}

.ViewBookingDetails-photoBg-TWR6D {
    width: 100%;
    border-radius: 15px;
    -o-object-fit: contain;
       object-fit: contain;
    height: 140px;
}

.ViewBookingDetails-lineBreak-JddDA {
    white-space: pre-line;
}

.ViewBookingDetails-timerGrid-Vt3ku {
    display: grid;
    grid-template-columns: 1fr 1fr;
    max-width: 60%;
}

.ViewBookingDetails-timeLinePhoto-eTDDT {
    width: 80px;
    height: 65px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border-radius: 7px 0px;

}

.ViewBookingDetails-displayFlexTimeLine-dPavc {
    display: grid;
    grid-template-columns: 80px auto;
}

.ViewBookingDetails-printImage-kBitS {
    width: 100%;
    height: 65px;
    border-radius: 7px 0;
}

.ViewBookingDetails-directionRTLPrint-epTRK {
    direction: rtl;
    text-align: right;
}

.ViewBookingDetails-alignRightRTLPrint-ENg6f {
    text-align: right;
    padding-right: 15px;
}

.ViewBookingDetails-paddingRightRTL-JOmm8 {
    padding-right: 24px;
}

.ViewBookingDetails-nameTextRTL-l7Y6w {
    padding-right: 12px;
}

.ViewBookingDetails-dFlex-OrN0y {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    gap: 15px;
}

.ViewBookingDetails-faqImage-zwuGX {
    width: 100%;
    max-width: 19px;
    vertical-align: top;
    margin: 4px 5px 0;
}

.ViewBookingDetails-viewBookingTableColumnCelDifWidth-aFu5z {
    min-width: 155px;
}

.ViewBookingDetails-ViewScheduleBookingAccordionHeader-kulRu,
.ViewBookingDetails-ViewScheduleBookingAccordionHeader-kulRu:hover,
.ViewBookingDetails-ViewScheduleBookingAccordionHeader-kulRu:focus,
.ViewBookingDetails-ViewScheduleBookingAccordionHeader-kulRu:active:hover,
.ViewBookingDetails-ViewScheduleBookingAccordionHeader-kulRu:active:focus {
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    padding: 8px 12px 8px 12px;
    border: 1px solid var(--primary-border);
    background: var(--background-secondary);
    outline: none;
    -webkit-box-shadow: none;
            box-shadow: none;
    color: var(--primary-foreground);
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    border-radius: 6px;
}

.ViewBookingDetails-ViewScheduleBookingAccordionHeaderRadius-HH7xq,
.ViewBookingDetails-ViewScheduleBookingAccordionHeaderRadius-HH7xq:hover,
.ViewBookingDetails-ViewScheduleBookingAccordionHeaderRadius-HH7xq:focus,
.ViewBookingDetails-ViewScheduleBookingAccordionHeaderRadius-HH7xq:active:hover,
.ViewBookingDetails-ViewScheduleBookingAccordionHeaderRadius-HH7xq:active:focus {
    border-radius: 6px 6px 0 0;
}

.ViewBookingDetails-ViewScheduleBookingAccordionArrow-OuQAq {
    position: relative;
    width: 22px;
    height: 22px;
}

.ViewBookingDetails-ViewScheduleBookingAccordionArrow-OuQAq img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
       object-fit: contain;
}

@media screen and (max-width: 1023px) {
    .ViewBookingDetails-circleHeight-UvgJx {
        height: auto;
    }

    .ViewBookingDetails-circleHeight-UvgJx:nth-child(2) .ViewBookingDetails-circle-i16hD::after {
        background: transparent !important;
    }

    .ViewBookingDetails-circleHeight-UvgJx:nth-child(3) .ViewBookingDetails-circle-i16hD::after {
        background: transparent !important;
    }
}

@media screen and (max-width: 767px) {
    .ViewBookingDetails-dFlex-OrN0y {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
    }

    .ViewBookingDetails-viewBookingTableColumnCelWidth-j_q7n {
        min-width: 250px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Common.css","webpack://./src/components/responsive-common.css","webpack://./src/components/ViewBookingDetails/ViewBookingDetails.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;;AACjB;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA,eAAe;;AAEf,WAAW;;AAEX;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,2CAA2C;IAC3C,eAAe;IACf,oCAAoC;AACxC;;AAEA;;;IAGI,kDAAkD;AACtD;;AAEA,WAAW;;AAEX,cAAc;;AACd;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;;IAGI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,cAAc;;AAEd;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;;IAGI,qBAAqB;IACrB,kCAAkC;IAClC,4CAA4C;IAC5C,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,mCAAmC;;AAEvC;;AAEA;IACI,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;IAC3B,eAAe;IACf,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA,+DAA+D;;AAC/D;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,gDAAgD;IAChD,iCAAiC;IACjC,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA,6DAA6D;;AAC7D;;IAEI,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;AAEJ;;AC1OA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;;AAGF;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;IACE,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,sBAAsB;EACxB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,mCAA2B;IAA3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sCAAsC;IACtC,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAGA;EACE;IACE,uBAAuB;EACzB;AACF;;ACxPA;IACI,YAAY;IACZ,gDAAgD;IAChD,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,SAAS;IACT,UAAU;IACV,+CAA+C;IAC/C,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,SAAS;IACT,UAAU;IACV,sDAAsD;IACtD,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uCAAuC;IACvC,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,sBAAmB;OAAnB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,sBAAsB;;AAE1B;;AAEA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,mBAAe;QAAf,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;;;IAKI,WAAW;IACX,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,0BAA0B;IAC1B,uCAAuC;IACvC,uCAAuC;IACvC,aAAa;IACb,wBAAgB;YAAhB,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;;;IAKI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,kCAAkC;IACtC;AACJ;;AAEA;IACI;QACI,4BAAsB;QAAtB,6BAAsB;YAAtB,0BAAsB;gBAAtB,sBAAsB;QACtB,wBAAuB;YAAvB,qBAAuB;gBAAvB,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".containerWith {\n    width: 100%;\n    max-width: 1260px !important;\n    margin: 0 auto;\n}\n\n.container {\n    max-width: 100%;\n}\n\n/* Text - Start */\n.subText {\n    color: var(--secondary-foreground);\n    font-size: 14px;\n}\n\n/* Text - End */\n\n/* Header */\n\n.navigationLink a {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n    color: var(--primary-foreground) !important;\n    font-size: 18px;\n    border-bottom: 2px solid transparent;\n}\n\n.navigationLink a:hover,\n.navigationLink a:focus,\n.navigationLink a:active {\n    border-bottom: 2px solid var(--primary-foreground);\n}\n\n/* Header */\n\n/* commonCss */\n.noPadding {\n    padding: 0;\n}\n\n.heading {\n    padding: 30px 0px 24px 0px;\n    font-weight: 700;\n    font-size: 24px;\n    color: var(--primary-foreground);\n}\n\n.widthInner {\n    margin: 0px auto 0px auto;\n    border-radius: 4px;\n    padding: 0px;\n    margin: 0px 15px 30px;\n}\n\n.noMargin {\n    margin: 0;\n}\n\n.formControlInputTable {\n    border: none;\n    width: 100px;\n    height: auto;\n}\n\n.backBtn {\n    margin-left: 15px;\n    display: inline-block;\n}\n\n.backBtn:active,\n.backBtn:hover,\n.backBtn:focus {\n    color: var(--primary-bg);\n    text-decoration: none !important;\n}\n\n.textAlignRight {\n    text-align: right;\n}\n\n.displayInlineBlock {\n    display: inline-block;\n}\n\n.displayBlock {\n    display: block;\n}\n\n.countryCode {\n    width: 15%;\n    vertical-align: top;\n}\n\n.vtrMiddle {\n    vertical-align: middle;\n}\n\n/* commonCss */\n\n.editIcon {\n    width: 100%;\n    width: 15px;\n    vertical-align: middle;\n    margin-right: 3px;\n}\n\n.iconBtn,\n.iconBtn:hover,\n.iconBtn:focus {\n    padding: 0 !important;\n    background: transparent !important;\n    color: var(--danger-action-color) !important;\n    border: 0 !important;\n    white-space: nowrap;\n    font-size: 16px !important;\n    text-decoration: unset !important;\n    cursor: pointer;\n}\n\n.profileImg {\n    width: 100%;\n    height: auto;\n    margin-bottom: 18px;\n}\n\n.profileImgSection {\n    width: 100%;\n    margin: 0 auto;\n    padding: 30px;\n    border-radius: 12px;\n    border: 1px solid var(--primary-border);\n    background: var(--primary-input-bg);\n\n}\n\n.profileImgWidth {\n    margin: 0;\n    max-width: 100% !important;\n}\n\n.searchInput {\n    width: 100%;\n    max-width: 320px;\n}\n\n.backgroundImg {\n    padding-top: 42%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    margin-bottom: 18px;\n    border-radius: 4px;\n    background-color: transparent;\n    background-position: center;\n    margin-top: 6px;\n    border: 1px dashed var(--primary-border);\n    border-radius: 12px;\n}\n\n/*******************Export CSV section start ******************/\n.exportDisplay {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-bottom: 18px;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.exportTextSection {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.exportText {\n    display: inline-block;\n    padding-right: 5px;\n}\n\n.exportTextContainer {\n    display: flex;\n    align-items: center;\n    color: var(--primary-link-foreground) !important;\n    text-decoration: unset !important;\n    border-bottom: 1px solid var(--primary-link-foreground);\n}\n\n.vtrTextBottom {\n    vertical-align: text-bottom;\n}\n\n.exportImg {\n    width: 100%;\n    max-width: 14px;\n    height: 14px;\n    object-fit: contain;\n}\n\n/*******************Export CSV section End ******************/\n.noLink,\n.noLink:hover {\n    color: var(--primary-link-foreground) !important;\n    cursor: pointer;\n}\n\n.singleCard {\n    width: 500px;\n    margin: 0 auto;\n}\n\n.defaultIcon {\n    background-size: 50px;\n}\n\n.assignProviderSearchInput {\n    width: 100%;\n    max-width: 324px;\n}\n\n.searchGroupContainer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-grow: 1;\n}\n\n@media (max-width: 767px) {\n    .searchGroupContainer {\n        width: 100%;\n    }\n\n}","@media (max-width: 1199px) and (min-width: 1024px) {\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .aboutGrid img {\n    position: relative;\n    top: -25px !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 175px !important;\n  }\n\n  .positionFive {\n    top: 28% !important;\n  }\n\n  .positionTwo {\n    top: 28% !important;\n  }\n\n  .responsiveContentOne {\n    top: -50px !important;\n  }\n\n  .positionFour {\n    top: -50px !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n\n}\n\n@media (max-width: 1024px) {\n  .navbar-expand-lg .navbar-toggler {\n    display: block !important;\n    position: absolute;\n    top: 23px;\n    right: 20px;\n  }\n\n  .profileImgSection {\n    padding: 18px;\n  }\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .responsiveContentOne {\n    width: 300px !important;\n    position: absolute !important;\n    top: -42px !important;\n    left: -5% !important;\n  }\n\n  .positionTwo {\n    top: 24% !important;\n    left: -5% !important;\n  }\n\n  .positionThree {\n    top: 70% !important;\n    left: -5% !important;\n  }\n\n  .positionFour {\n    top: -42px !important;\n    right: -5% !important;\n  }\n\n  .positionFive {\n    top: 20% !important;\n    right: -5% !important;\n  }\n\n  .positionSix {\n    top: 70% !important;\n    right: -5% !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 115px !important;\n  }\n\n  .aboutGrid img {\n    top: -1px !important;\n  }\n\n  .contentOne h1 {\n    font-size: 16px !important;\n  }\n\n  .contentOne p {\n    font-size: 12px !important;\n  }\n\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .padding {\n    padding: 0px 0 0 60px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n@media screen and (max-width: 823px) {\n  .navbar-collapse.show {\n    right: 0% !important;\n    top: 0 !important;\n  }\n\n  .navbar-collapse {\n    position: fixed !important;\n    height: 100vh !important;\n    width: 100% !important;\n    background: #fff !important;\n    right: -100% !important;\n    transition: 0.5s !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .content {\n    float: none;\n  }\n\n  .mr-auto.navbar-nav {\n    padding-bottom: 80px !important;\n  }\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .footer {\n    padding: 35px 0 0 15px;\n  }\n\n  .widthInner {\n    width: 100%;\n    margin: 0px auto 0 auto;\n    border-radius: 0;\n  }\n\n  .responsiveNoPadding {\n    padding: 0px !important;\n  }\n\n  .contentOne {\n    position: relative !important;\n    text-align: left !important;\n    width: auto !important;\n    padding: 0px 15px !important;\n  }\n\n  .aboutContainer {\n    padding: 30px 0 30px !important;\n  }\n\n  .noPosition {\n    left: 0 !important;\n    right: 0 !important;\n    top: 0 !important;\n  }\n\n  .mobimleImg {\n    display: none !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .imgWidth {\n    padding: 18px !important;\n  }\n\n  .searchInput,\n  .assignProviderSearchInput {\n    max-width: 100% !important;\n  }\n\n  .exportText {\n    display: inline-block;\n  }\n\n  .gridSystem {\n    grid-template-columns: auto !important;\n  }\n\n  .padding {\n    padding: 52px 0 0 0 !important;\n  }\n\n  .heading {\n    padding: 30px 0 24px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .displayGrid {\n    grid-template-columns: 100% !important;\n    grid-gap: 12px;\n  }\n\n  .boxInner {\n    padding: 35px 0 !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n\n@media (max-width: 480px) and (min-width: 320px) {\n  .whiteDropdown select {\n    width: 120px !important;\n  }\n}","@import '../../components/Common.css';\n@import '../../components/responsive-common.css';\n\n\n.addOrChangeBtn {\n    float: right;\n    color: var(--primary-link-foreground) !important;\n    text-decoration: underline !important;\n    cursor: pointer;\n}\n\n.grid {\n    display: grid;\n    grid-template-columns: 25px auto;\n    grid-gap: 12px;\n    padding-bottom: 20px;\n    position: relative;\n    height: 65px;\n}\n\n.iconWidth {\n    width: 100%;\n    max-width: 25px;\n}\n\n.smallContent {\n    font-size: 14px;\n    color: var(--secondary-foreground);\n}\n\n.grid::after {\n    content: '';\n    position: absolute;\n    z-index: 1;\n    top: 29px;\n    bottom: 0;\n    left: 12px;\n    border-left: 1.5px dashed var(--primary-border);\n    height: 40px;\n}\n\n.grid:last-child::after {\n    display: none;\n}\n\n.grid:last-child {\n    padding-bottom: 0;\n    height: auto;\n}\n\n.completed {\n    position: relative;\n}\n\n.completed::after {\n    content: '';\n    position: absolute;\n    z-index: 1;\n    top: 29px;\n    bottom: 0;\n    left: 12px;\n    border-left: 1.5px dashed var(--primary-bg) !important;\n    height: 40px;\n}\n\n.paddingTop {\n    padding-top: 15px;\n}\n\n.tableGrid {\n    display: grid;\n    grid-template-columns: 100% auto;\n}\n\n.tablePadding {\n    padding-left: 10px;\n}\n\n.fontCss {\n    font-size: 15px;\n    color: var(--secondary-foreground);\n}\n\n.downIconCss {\n    position: absolute;\n    top: 30px;\n    right: 20px;\n    font-size: 24px;\n}\n\n.name {\n    padding-left: 12px;\n    display: inline-block;\n    padding-right: 40px;\n}\n\n.pricingCss {\n    font-size: 14px;\n    color: var(--primary-bg);\n    padding-top: 2px;\n}\n\n.timeCss {\n    padding-left: 6px;\n    position: relative;\n    top: 1px;\n}\n\n.timeGrid {\n    display: grid;\n    grid-template-columns: 33.33% 33.33% 33.33%;\n    padding: 13px 15px;\n    border-bottom: 1px solid var(--primary-border);\n}\n\n.timeGrid:last-child {\n    border-bottom: 0;\n}\n\n.totalCss {\n    padding: 15px;\n    border: 1px solid var(--primary-border);\n    max-width: 350px;\n    border-radius: 10px;\n    margin: 15px auto;\n    text-align: center;\n}\n\n.subCategoryImage {\n    width: 100%;\n    max-width: 100px;\n}\n\n.jobPhotos {\n    margin-bottom: 15px;\n    cursor: pointer;\n}\n\n.photoBg {\n    width: 100%;\n    border-radius: 15px;\n    object-fit: contain;\n    height: 140px;\n}\n\n.lineBreak {\n    white-space: pre-line;\n}\n\n.timerGrid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    max-width: 60%;\n}\n\n.timeLinePhoto {\n    width: 80px;\n    height: 65px;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n    border-radius: 7px 0px;\n\n}\n\n.displayFlexTimeLine {\n    display: grid;\n    grid-template-columns: 80px auto;\n}\n\n.printImage {\n    width: 100%;\n    height: 65px;\n    border-radius: 7px 0;\n}\n\n.directionRTLPrint {\n    direction: rtl;\n    text-align: right;\n}\n\n.alignRightRTLPrint {\n    text-align: right;\n    padding-right: 15px;\n}\n\n.paddingRightRTL {\n    padding-right: 24px;\n}\n\n.nameTextRTL {\n    padding-right: 12px;\n}\n\n.dFlex {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 15px;\n}\n\n.faqImage {\n    width: 100%;\n    max-width: 19px;\n    vertical-align: top;\n    margin: 4px 5px 0;\n}\n\n.viewBookingTableColumnCelDifWidth {\n    min-width: 155px;\n}\n\n.ViewScheduleBookingAccordionHeader,\n.ViewScheduleBookingAccordionHeader:hover,\n.ViewScheduleBookingAccordionHeader:focus,\n.ViewScheduleBookingAccordionHeader:active:hover,\n.ViewScheduleBookingAccordionHeader:active:focus {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 12px 8px 12px;\n    border: 1px solid var(--primary-border);\n    background: var(--background-secondary);\n    outline: none;\n    box-shadow: none;\n    color: var(--primary-foreground);\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    border-radius: 6px;\n}\n\n.ViewScheduleBookingAccordionHeaderRadius,\n.ViewScheduleBookingAccordionHeaderRadius:hover,\n.ViewScheduleBookingAccordionHeaderRadius:focus,\n.ViewScheduleBookingAccordionHeaderRadius:active:hover,\n.ViewScheduleBookingAccordionHeaderRadius:active:focus {\n    border-radius: 6px 6px 0 0;\n}\n\n.ViewScheduleBookingAccordionArrow {\n    position: relative;\n    width: 22px;\n    height: 22px;\n}\n\n.ViewScheduleBookingAccordionArrow img {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n@media screen and (max-width: 1023px) {\n    .circleHeight {\n        height: auto;\n    }\n\n    .circleHeight:nth-child(2) .circle::after {\n        background: transparent !important;\n    }\n\n    .circleHeight:nth-child(3) .circle::after {\n        background: transparent !important;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .dFlex {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .viewBookingTableColumnCelWidth {\n        min-width: 250px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerWith": `ViewBookingDetails-containerWith-Qwcfk`,
	"container": `ViewBookingDetails-container-wtluc`,
	"subText": `ViewBookingDetails-subText-Tesbg`,
	"navigationLink": `ViewBookingDetails-navigationLink-XFfyM`,
	"noPadding": `ViewBookingDetails-noPadding-xIlhz`,
	"heading": `ViewBookingDetails-heading-T_i6d`,
	"widthInner": `ViewBookingDetails-widthInner-A0PjK`,
	"noMargin": `ViewBookingDetails-noMargin-uYGmq`,
	"formControlInputTable": `ViewBookingDetails-formControlInputTable-eEHMc`,
	"backBtn": `ViewBookingDetails-backBtn-rFfSh`,
	"textAlignRight": `ViewBookingDetails-textAlignRight-QSESo`,
	"displayInlineBlock": `ViewBookingDetails-displayInlineBlock-woiDM`,
	"displayBlock": `ViewBookingDetails-displayBlock-QUnPr`,
	"countryCode": `ViewBookingDetails-countryCode-nH1k9`,
	"vtrMiddle": `ViewBookingDetails-vtrMiddle-audPC`,
	"editIcon": `ViewBookingDetails-editIcon-O_vPC`,
	"iconBtn": `ViewBookingDetails-iconBtn-NPKiq`,
	"profileImg": `ViewBookingDetails-profileImg-QQtJ6`,
	"profileImgSection": `ViewBookingDetails-profileImgSection-nZ51z`,
	"profileImgWidth": `ViewBookingDetails-profileImgWidth-Ay6gi`,
	"searchInput": `ViewBookingDetails-searchInput-rpEDD`,
	"backgroundImg": `ViewBookingDetails-backgroundImg-JMxaC`,
	"exportDisplay": `ViewBookingDetails-exportDisplay-OM8AK`,
	"exportTextSection": `ViewBookingDetails-exportTextSection-xy5JT`,
	"exportText": `ViewBookingDetails-exportText-jZGlX`,
	"exportTextContainer": `ViewBookingDetails-exportTextContainer-frCYU`,
	"vtrTextBottom": `ViewBookingDetails-vtrTextBottom-OK7AR`,
	"exportImg": `ViewBookingDetails-exportImg-Dkqaq`,
	"noLink": `ViewBookingDetails-noLink-IlcBP`,
	"singleCard": `ViewBookingDetails-singleCard-V8UgY`,
	"defaultIcon": `ViewBookingDetails-defaultIcon-YnNPB`,
	"assignProviderSearchInput": `ViewBookingDetails-assignProviderSearchInput-xlVjG`,
	"searchGroupContainer": `ViewBookingDetails-searchGroupContainer-Fd2ND`,
	"aboutGrid": `ViewBookingDetails-aboutGrid-ZtIsD`,
	"responsiveView": `ViewBookingDetails-responsiveView-sGjt0`,
	"positionFive": `ViewBookingDetails-positionFive-joHMf`,
	"positionTwo": `ViewBookingDetails-positionTwo-ERm4I`,
	"responsiveContentOne": `ViewBookingDetails-responsiveContentOne-jmfy6`,
	"positionFour": `ViewBookingDetails-positionFour-BecV8`,
	"totalCss": `ViewBookingDetails-totalCss-YlpZc`,
	"navbar-expand-lg": `ViewBookingDetails-navbar-expand-lg-MXk91`,
	"navbar-toggler": `ViewBookingDetails-navbar-toggler-xs4I4`,
	"positionThree": `ViewBookingDetails-positionThree-YoZ3S`,
	"positionSix": `ViewBookingDetails-positionSix-YAiCw`,
	"contentOne": `ViewBookingDetails-contentOne-iYSmI`,
	"padding": `ViewBookingDetails-padding-OAsta`,
	"navbar-collapse": `ViewBookingDetails-navbar-collapse-LuWqc`,
	"show": `ViewBookingDetails-show-WL5NK`,
	"content": `ViewBookingDetails-content-C_VIc`,
	"mr-auto": `ViewBookingDetails-mr-auto-Rf3hm`,
	"navbar-nav": `ViewBookingDetails-navbar-nav-p9GJN`,
	"footer": `ViewBookingDetails-footer-Y_azl`,
	"responsiveNoPadding": `ViewBookingDetails-responsiveNoPadding-mn5tc`,
	"aboutContainer": `ViewBookingDetails-aboutContainer-XDtaG`,
	"noPosition": `ViewBookingDetails-noPosition-tCPud`,
	"mobimleImg": `ViewBookingDetails-mobimleImg-vNAKj`,
	"imgWidth": `ViewBookingDetails-imgWidth-DQ9cO`,
	"gridSystem": `ViewBookingDetails-gridSystem-z2JGr`,
	"displayGrid": `ViewBookingDetails-displayGrid-Uw3sr`,
	"boxInner": `ViewBookingDetails-boxInner-P2XY0`,
	"whiteDropdown": `ViewBookingDetails-whiteDropdown-UPNRO`,
	"addOrChangeBtn": `ViewBookingDetails-addOrChangeBtn-y9Vzj`,
	"grid": `ViewBookingDetails-grid-Fis0H`,
	"iconWidth": `ViewBookingDetails-iconWidth-hx_No`,
	"smallContent": `ViewBookingDetails-smallContent-dfPGt`,
	"completed": `ViewBookingDetails-completed-IHqMi`,
	"paddingTop": `ViewBookingDetails-paddingTop-hkA4_`,
	"tableGrid": `ViewBookingDetails-tableGrid-YyXiN`,
	"tablePadding": `ViewBookingDetails-tablePadding-hd5Cs`,
	"fontCss": `ViewBookingDetails-fontCss-lso5x`,
	"downIconCss": `ViewBookingDetails-downIconCss-mcl9A`,
	"name": `ViewBookingDetails-name-g2M6e`,
	"pricingCss": `ViewBookingDetails-pricingCss-XV27u`,
	"timeCss": `ViewBookingDetails-timeCss-lqu4h`,
	"timeGrid": `ViewBookingDetails-timeGrid-T2XFR`,
	"subCategoryImage": `ViewBookingDetails-subCategoryImage-XsU9O`,
	"jobPhotos": `ViewBookingDetails-jobPhotos-EVT6c`,
	"photoBg": `ViewBookingDetails-photoBg-TWR6D`,
	"lineBreak": `ViewBookingDetails-lineBreak-JddDA`,
	"timerGrid": `ViewBookingDetails-timerGrid-Vt3ku`,
	"timeLinePhoto": `ViewBookingDetails-timeLinePhoto-eTDDT`,
	"displayFlexTimeLine": `ViewBookingDetails-displayFlexTimeLine-dPavc`,
	"printImage": `ViewBookingDetails-printImage-kBitS`,
	"directionRTLPrint": `ViewBookingDetails-directionRTLPrint-epTRK`,
	"alignRightRTLPrint": `ViewBookingDetails-alignRightRTLPrint-ENg6f`,
	"paddingRightRTL": `ViewBookingDetails-paddingRightRTL-JOmm8`,
	"nameTextRTL": `ViewBookingDetails-nameTextRTL-l7Y6w`,
	"dFlex": `ViewBookingDetails-dFlex-OrN0y`,
	"faqImage": `ViewBookingDetails-faqImage-zwuGX`,
	"viewBookingTableColumnCelDifWidth": `ViewBookingDetails-viewBookingTableColumnCelDifWidth-aFu5z`,
	"ViewScheduleBookingAccordionHeader": `ViewBookingDetails-ViewScheduleBookingAccordionHeader-kulRu`,
	"ViewScheduleBookingAccordionHeaderRadius": `ViewBookingDetails-ViewScheduleBookingAccordionHeaderRadius-HH7xq`,
	"ViewScheduleBookingAccordionArrow": `ViewBookingDetails-ViewScheduleBookingAccordionArrow-OuQAq`,
	"circleHeight": `ViewBookingDetails-circleHeight-UvgJx`,
	"circle": `ViewBookingDetails-circle-i16hD`,
	"viewBookingTableColumnCelWidth": `ViewBookingDetails-viewBookingTableColumnCelWidth-j_q7n`
};
module.exports = ___CSS_LOADER_EXPORT___;
